/**
 * Root Reducer
 */
import { combineReducers } from 'redux';

// Import Reducers
import errors from './modules/App/ErrorsReducer';
import app from './modules/App/AppReducer';
import auth from './modules/Auth/AuthReducer';
import intl from './modules/Intl/IntlReducer';
import subscription from './modules/Subscribe/SubscribeReducer';
import digital from './modules/DigitalProgram/AddonReducer';
import billing from './modules/Billing/BillingReducer';
import wallboards from './modules/Wallboards/WallboardsReducer';
import forecasting from './modules/Forecasting/ForecastingReducer';
import filters from './components/Filter/FilterReducer';
import dashboards from './components/DashboardSelector/DashboardSelectorReducer';
import insights from './components/Insights/InsightsReducer';
import users from './modules/Users/UsersReducer';
import boards from './modules/Dashboards/DashboardsReducer';
import permissions from './modules/Permissions/PermissionsReducer';
import report from './modules/ReportConfig/ReportReducer';
import portfolio from './modules/Portfolios/PortfolioReducer';
import notifications from './modules/Notifications/NotificationsReducer';

import overview from './modules/Overview/OverviewReducer';
import process from './modules/ProcessImprovement/ProcessImprovementReducer';
import cfd from './modules/CFD/CFDReducer';
import ctsp from './modules/CycleTimeScatterPlot/CTSPReducer';
import ctb from './modules/CycleTimeBreakdown/CTBReducer';
import cth from './modules/CycleTimeHistogram/CTHReducer';
import cta from './modules/CycleTimeAging/CTAReducer';
import throughput from './modules/Throughput/ThroughputReducer';
import throughputHistogram from './modules/ThroughputHistogram/ThroughputHistogramReducer';
import fe from './modules/FlowEfficiency/FlowEfficiencyReducer';
import ddp from './modules/DueDatePerformance/DueDatePerformanceReducer';
import exporting from './modules/Exporting/ExportingReducer';
import mc from './modules/MonteCarlo/MonteCarloReducer';
import mct from './modules/MonteCarloTasks/MonteCarloTasksReducer';

import sso from './modules/Sso/SsoReducer';
import tenant from './modules/Tenant/TenantReducer';
import consent from './modules/Common/ConsentReducer';

// Combine all reducers into one root reducer
export default combineReducers({
  errors,
  app,
  auth,
  intl,
  subscription,
  digital,
  billing,
  filters,
  dashboards,
  insights,
  permissions,
  overview,
  process,
   cfd,
  ctsp,
  ctb,
  cth,
  cta,
  throughput,
  throughputHistogram,
  fe,
  ddp,
  mc,
  mct,
  exporting,
  wallboards,
  forecasting,
  users,
  boards,
  notifications,
  sso,
  tenant,
  report,
  portfolio,
  consent,
});
